import React, { useState, useRef, useEffect } from "react";
import { jsPDF } from "jspdf";
import { consultarFacturas, obtenerInformacionFactura } from "../services/facturaservice";
import QRCode from "qrcode";
import JsBarcode from "jsbarcode";
import { obtenerImagenesMacros, obtenerImagenesMacrosLineas } from "../services/imagenesservice";
import LoaderDialog from "./loading";

const ConsultaFacturas = ({ tipoUsuario }) => {
    const [suscripcion, setSuscripcion] = useState("");
    const [resultados, setResultados] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const canvasRef = useRef(null);
    const URL_DIAN = `${process.env.REACT_APP_URL_DIAN}`;
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768); // 768px es un punto común para tablets/móviles
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    // Si es móvil, invertir el orden de los resultados
    const resultadosInvertidos = isMobile ? [...resultados].reverse() : resultados;


    const formatearNumero = (numero, total) => {
        const formateado = numero.toString().padStart(total, "0");
        return formateado;
    };

    const validarInsercionNumeros = (event) => {
        const char = event.key;
        // Permitir solo números y teclas de control como Backspace, Tab, etc.
        if (!/[0-9]/.test(char) && !['Backspace', 'Tab'].includes(event.key)) {
            event.preventDefault(); // Bloquea la tecla no válida
        }
    }

    const manejarConsultaFacturas = async () => {
        setLoading(true); // Activar loader
        if (!suscripcion) {
            setLoading(false); // Activar loader
            setMensaje("Por favor, ingrese un número de suscripción.");
            return;
        }
        try {
            const datos = await consultarFacturas(suscripcion);
            if (datos.resultados != undefined) {
                setResultados(datos?.resultados || []); // Validación de datos
                setMensaje("");

            } else {
                setMensaje(datos.mensaje);
                setResultados([]);
            }
        } catch (error) {
            setMensaje(error.message);
            setResultados([]);
        } finally {
            setLoading(false); // Desactivar loader
        }
    };


    const generarCodigoBarrasBase64 = (valor) => {
        const canvas = document.createElement("canvas"); // Crear un canvas temporal
        JsBarcode(canvas, valor, {
            format: "CODE128",
            lineColor: "#000",
            width: 2,
            height: 50,
            displayValue: false,
            margin: 0,
        });

        return canvas.toDataURL("image/png"); // Convertir el canvas en base64
    };

    const contarCantidadServicios = (infFactura) => {
        let cantidad = 0;
        for (let i = 0; i < infFactura.length; i++) {
            if (infFactura[i]?.[0] == "2") {
                cantidad++;
            }

        }
        return cantidad;
    }

    const consultarInformacionFactura = async (archivo, suscripcion, factura, mes) => {
        if (!suscripcion) {
            setMensaje("Por favor, ingrese un número de suscripción.");
            return [];
        }
        try {
            const datos = await obtenerInformacionFactura(archivo, suscripcion, factura, mes);
            return datos; // Validación de datos

        } catch (error) {
            setMensaje(error.message);
            return [];
        }
    };

    const generarPDF = async (archivo, mes, valor, factura) => {
        const doc = new jsPDF();
        setLoading(true);
        try {
            // Información de la factura
            const inf = await consultarInformacionFactura(archivo, suscripcion, factura.trim(), mes.toLowerCase());

            let infFactura = inf.lineas;
            let infDIAN = inf.datos_dian || [];
            let conLlamadas = false;
            let nombreSuscriptor = "";
            let direccion = ""
            let facturaVenta = factura
            let periodoFacturado = ""
            let telefono = "";
            let cantidadServiciosFactura = contarCantidadServicios(infFactura);
            let minServiciosPagina = 2;
            // Obtener imágenes del servidor
            let imageData = await obtenerImagenesMacros();
            let imageDataLineas = await obtenerImagenesMacrosLineas();
            let adicionarPaginaTelefono = true;
            let adicionarPagina = false;

            if (!Array.isArray(imageData) || imageData.length === 0) {
                alert("No se encontraron imágenes en el servidor.");
                return;
            }

            let imgUrl = imageData[0].imagen;
            let imgUrlConsulta = imageDataLineas[0].imagen;
            if (infFactura.length > 0) {
                if (infFactura[infFactura.length - 1][0] === "12") {
                    conLlamadas = true;
                    if (cantidadServiciosFactura <= 4) {
                        imgUrl = imageData[1].imagen;
                        minServiciosPagina = 2;
                        adicionarPaginaTelefono = false;
                        adicionarPagina = false;
                    } else {
                        imgUrl = imageData[0].imagen;
                        minServiciosPagina = 4;
                        adicionarPaginaTelefono = true;
                        adicionarPagina = true;


                    }
                } else {
                    conLlamadas = false;
                    imgUrl = imageData[0].imagen;
                }
            } else {
                conLlamadas = false;
                imgUrl = null;
            }

            if (infFactura.length > 0) {
                if (infFactura[infFactura.length - 1][0] === "12") {
                    conLlamadas = true;
                    if (cantidadServiciosFactura <= 4) {
                        imgUrlConsulta = imageDataLineas[1].imagen;
                    } else {
                        imgUrlConsulta = imageDataLineas[0].imagen;
                    }

                } else {
                    conLlamadas = false;
                    imgUrlConsulta = imageDataLineas[0].imagen;
                }
            } else {
                conLlamadas = false;
                imgUrlConsulta = null;
            }

            if (tipoUsuario != 'consulta') {
                doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
            } else {
                doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
            }

            //agregar datos DIAN
            if (infDIAN.length > 0) {
                let dataParaQR = URL_DIAN + infDIAN[1];
                const qrCodeDataURL = await QRCode.toDataURL(dataParaQR, {
                    margin: 0, // Eliminar márgenes
                });
                doc.addImage(qrCodeDataURL, "PNG", 10, 197, 21, 21); // X, Y, Width, Height
                // Agregar texto adicional al PDF (opcional)
                doc.setFontSize(7);
                doc.text("CUDE: " + infDIAN[1], 35, 200); // X, Y, Width, Height
                doc.text("Fecha hora de generación: " + infDIAN[2], 35, 203); // X, Y, Width, Height

            }

            // Agregar contenido al PDF
            let cantidad = 30;
            let baseValue = 25; // Valor base inicial
            let numeroCuenta = "";
            let baseLlamadas = 100;
            let posicionLlamada = 6;
            let llamdasPrimeraPagina = 0;

            let cantidadServicios = 30;
            let baseValueServicios = 25; // Valor base inicial
            let baseLlamadasServicios = 100;
            let posicionLlamadaServicios = 7;
            let llamadasPrimeraPaginaServicios = 0;

            let baseValueConLlamada = 25; // Valor base inicial
            let baseConLlamadas = 100;
            let posicionConLlamada = 7;
            let llamadasPrimeraPaginaConLlamada = 0;



            let nombreArchivo = "";
            if (!conLlamadas) {
                let primeraPaginaServicios = 0;

                for (let i = 0; i < infFactura.length; i++) {
                    if (infFactura[i]?.[0] == "1") {
                        doc.setFontSize(7);

                        doc.text(`${infFactura[i]?.[1] || ''}`, 30, 18);
                        nombreSuscriptor = infFactura[i]?.[1];
                        let identificacion = infFactura[i]?.[2].split(" ");

                        doc.text(`${identificacion[1]}`, 80, 18);

                        direccion = infFactura[i]?.[3];

                        if (direccion && !direccion.includes("----")) {
                            doc.text(`${direccion}`, 30, 21); // Imprime el valor solo si no contiene "-"
                        } else {
                            doc.text('', 30, 21); // Imprime el valor solo si no contiene "-"

                        }
                        doc.text(`${infFactura[i]?.[4].trim() || ''}${'  '} ${infFactura[i]?.[5].trim() || ''}`, 30, 24);

                        doc.text(`${infFactura[i]?.[6] || ''}`, 137, 21);

                        doc.text(`${infFactura[i]?.[6] || ''}`, 80, 289);

                        //categoria
                        doc.setFontSize(5);
                        doc.text(`${infFactura[i]?.[8] || ''}`, 145, 31);
                        doc.setFontSize(7);

                        doc.text(`${infFactura[i]?.[7] || ''}`, 113, 278);

                        doc.text(`${infFactura[i]?.[9] || ''}`, 163, 31);
                        doc.text(`${infFactura[i]?.[10] || ''}`, 136, 40);

                        doc.text(`${infFactura[i]?.[11] || ''}`, 144, 40);
                        //factura
                        doc.text(`${infFactura[i]?.[12] || ''}`, 180, 13);
                        doc.text(`${infFactura[i]?.[12] || ''}`, 80, 278);
                        nombreArchivo = infFactura[i]?.[12].trim();

                        //periodo facturado
                        doc.text(`${infFactura[i]?.[13] || ''}`, 176, 20);
                        doc.text(`${infFactura[i]?.[13] || ''}`, 40, 278);
                        periodoFacturado = infFactura[i]?.[13] || ''
                        doc.setFontSize(6);
                        doc.text(`${infFactura[i]?.[13] || ''}`, 80, 31);
                        doc.text(`${infFactura[i]?.[14] || ''}`, 105, 31);

                        doc.setFontSize(7);
                        //pago antes de 
                        doc.text(`${infFactura[i]?.[16] || ''}`, 178, 40);
                        doc.text(`${infFactura[i]?.[16] || ''}`, 43, 289);

                        //fecha ultimo pago
                        doc.text(`${infFactura[i]?.[17] || ''}`, 179, 27);
                        //valor antes
                        doc.text(`${infFactura[i]?.[18].trim() || ''}`, 183, 33);
                        //mes deuda
                        doc.text(`${infFactura[i]?.[19].trim() || ''}`, 152, 289);
                        //fecha corte
                        doc.text(`${infFactura[i]?.[20] || ''}`, 95, 40);

                    }

                    if (infFactura[i]?.[0] == "2") {
                        if (primeraPaginaServicios == 0) {
                            if (llamadasPrimeraPaginaServicios < 4) {
                                doc.setFontSize(7);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                baseValueServicios += 3;
                                doc.text(`Servivio ${infFactura[i]?.[2] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                doc.text(`Cuenta ${infFactura[i]?.[3] || ''}`, posicionLlamadaServicios + 25, baseValueServicios + (cantidad));
                                baseValueServicios += 3;
                                numeroCuenta = infFactura[i]?.[3];
                                let salida = false;
                                let iterador = i + 1;
                                while (!salida) {
                                    if (infFactura[iterador]?.[0] == "3") {
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + cantidad);
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, posicionLlamadaServicios + 30, baseValueServicios + cantidad);

                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[3] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth;

                                        doc.text(`${infFactura[iterador]?.[3] || ''}`, rightAlignedX, baseValueServicios + cantidad);

                                        baseValueServicios += 3;

                                    } else if (infFactura[iterador]?.[0] == "4") {
                                        doc.setFontSize(7);
                                        if (infFactura[iterador]?.[1] == "1") {
                                            doc.text('Cuenta vencida N° ' + numeroCuenta, posicionLlamadaServicios, (baseValueServicios + cantidad));
                                        }
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValueServicios + cantidad);
                                        baseValueServicios += 3;


                                    } else if (infFactura[iterador]?.[0] == "20") {
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValueServicios + (cantidad));
                                        baseValueServicios += 3;
                                    } else {
                                        salida = true;
                                        baseValueServicios += 6;
                                    }
                                    iterador++;
                                }
                                baseLlamadasServicios += 3;
                                llamadasPrimeraPaginaServicios++;
                            } else {
                                if (posicionLlamadaServicios == 105) {
                                    baseLlamadasServicios = 100;
                                    llamadasPrimeraPaginaServicios = 0;
                                    posicionLlamadaServicios = 7;
                                    primeraPaginaServicios = 1;
                                    baseValueServicios = 25;
                                    doc.addPage();

                                    imgUrl = imageData[3].imagen;
                                    imgUrlConsulta = imageDataLineas[3].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseLlamadasServicios = 100;
                                    llamadasPrimeraPaginaServicios = 0;
                                    posicionLlamadaServicios = 105
                                    baseValueServicios = 25;
                                }

                            }
                        } else {
                            if (llamadasPrimeraPaginaServicios < 7) {
                                doc.text(nombreSuscriptor, 48, 20);
                                doc.text(telefono.trim(), 48, 25)
                                doc.text(direccion, 48, 31);
                                doc.text(facturaVenta, 160, 21);
                                doc.text(periodoFacturado, 162, 31);
                                doc.setFontSize(7);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                baseValueServicios += 3;
                                doc.text(`Servivio ${infFactura[i]?.[2] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                doc.text(`Cuenta ${infFactura[i]?.[3] || ''}`, posicionLlamadaServicios + 25, baseValueServicios + (cantidad));
                                baseValueServicios += 3;
                                numeroCuenta = infFactura[i]?.[3];
                                let salida = false;
                                let iterador = i + 1;
                                while (!salida) {
                                    if (infFactura[iterador]?.[0] == "3") {
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + cantidad);
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, posicionLlamadaServicios + 30, baseValueServicios + cantidad);

                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[3] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth;

                                        doc.text(`${infFactura[iterador]?.[3] || ''}`, rightAlignedX, baseValueServicios + cantidad);

                                        baseValueServicios += 3;

                                    } else if (infFactura[iterador]?.[0] == "4") {
                                        doc.setFontSize(7);
                                        if (infFactura[iterador]?.[1] == "1") {
                                            doc.text('Cuenta vencida N° ' + numeroCuenta, posicionLlamadaServicios, (baseValueServicios + cantidad));
                                        }
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValueServicios + cantidad);
                                        baseValueServicios += 3;


                                    } else if (infFactura[iterador]?.[0] == "20") {
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = (posicionLlamadaServicios + 93) - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionLlamadaServicios, baseValueServicios + (cantidad));
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValueServicios + (cantidad));
                                        baseValueServicios += 3;
                                    } else {
                                        salida = true;
                                        baseValueServicios += 6;
                                    }
                                    iterador++;
                                }
                                baseLlamadasServicios += 3;
                                llamadasPrimeraPaginaServicios++;
                            } else {
                                if (posicionLlamadaServicios == 105) {
                                    baseLlamadasServicios = 100;
                                    llamadasPrimeraPaginaServicios = 0;
                                    posicionLlamadaServicios = 7;
                                    primeraPaginaServicios = 1;
                                    baseValueServicios = 25;

                                    doc.addPage();

                                    imgUrl = imageData[2].imagen;
                                    imgUrlConsulta = imageDataLineas[2].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseLlamadasServicios = 100;
                                    llamadasPrimeraPaginaServicios = 0;
                                    posicionLlamadaServicios = 105
                                    baseValueServicios = 25;
                                }

                            }
                        }

                    }
                    if (infFactura[i]?.[0] == "8") {
                        if (primeraPaginaServicios == 0) {
                            doc.setPage(1)
                            if (infFactura[i]?.[1]?.includes('IVA') || infFactura[i]?.[1]?.includes('iva')) {
                                doc.text(`${infFactura[i]?.[1].slice(0, 10) || ''}`, 106, 191);
                                doc.text(`${infFactura[i]?.[2] || ''}`, 185, 191);
                            }
                        } else {
                            if (infFactura[i]?.[1]?.includes('IVA') || infFactura[i]?.[1]?.includes('iva')) {
                                doc.text(`${infFactura[i]?.[1].slice(0, 10) || ''}`, 106, 276);
                                doc.text(`${infFactura[i]?.[2] || ''}`, 185, 276);
                            }
                        }
                    }



                    if (infFactura[i]?.[0] == "10") {
                        doc.setPage(1);
                        doc.setFontSize(8);
                        // Verifica si el valor es un número antes de formatear
                        const numeroOriginal = infFactura[i]?.[2];
                        //cupon
                        doc.setFontSize(7);
                        doc.text(`${infFactura[i]?.[1] || ''}`, 156, 40);
                        doc.text(`${infFactura[i]?.[1].trim() || ''}`, 144, 277);
                        doc.setFontSize(8);
                        if (numeroOriginal != null && !isNaN(numeroOriginal)) {
                            const numeroFormateado = formatearNumero(Number(numeroOriginal), 10); // Convierte a número

                            let formateador = new Intl.NumberFormat('es-ES', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            let valorFormateado = formateador.format(numeroOriginal);

                            doc.text(`${valorFormateado || ''}`, 108, 23);

                            doc.text(`${valorFormateado || ''}`, 176, 282);

                            const numeroFormateadoID = formatearNumero(Number(infFactura[i]?.[1]), 12); // Convierte a número
                            const codigoBarras = `${415}${7707271939062}${8020}${numeroFormateadoID}${3900}${numeroFormateado}${96}${infFactura[i]?.[3]}`;
                            doc.text(codigoBarras, 60, 234 + cantidad);
                            const codBarrasGrafico = generarCodigoBarrasBase64(codigoBarras);
                            if (codBarrasGrafico) {
                                // Insertar imagen del código de barras en el PDF
                                doc.addImage(codBarrasGrafico, "PNG", 50, 245, 107, 16); // Ajustar tamaño y posición
                            } else {
                            }
                        } 
                        baseValue += 3;
                    }

                }
            } else {
                let primeraPagina = 0;
                let primeraPaginaConLlamada = 0;

                for (let i = 0; i < infFactura.length; i++) {
                    if (infFactura[i]?.[0] == "1") {
                        doc.setFontSize(7);
                        doc.text(`${infFactura[i]?.[1] || ''}`, 30, 18);
                        nombreSuscriptor = infFactura[i]?.[1] || '';
                        let identificacion = infFactura[i]?.[2].split(" ");

                        doc.text(`${identificacion[1]}`, 80, 18);

                        direccion = infFactura[i]?.[3];

                        if (direccion && !direccion.includes("-")) {
                            doc.text(`${direccion}`, 30, 21); // Imprime el valor solo si no contiene "-"
                        } else {
                            doc.text('', 30, 21); // Imprime el valor solo si no contiene "-"

                        }
                        doc.text(`${infFactura[i]?.[4].trim() || ''}${'  '} ${infFactura[i]?.[5].trim() || ''}`, 30, 24);
                        doc.text(`${infFactura[i]?.[6] || ''}`, 137, 21);
                        doc.text(`${infFactura[i]?.[6] || ''}`, 80, 289);

                        //categoria
                        doc.setFontSize(5);
                        doc.text(`${infFactura[i]?.[8] || ''}`, 145, 31);
                        doc.setFontSize(7);

                        doc.text(`${infFactura[i]?.[7] || ''}`, 113, 278);

                        doc.text(`${infFactura[i]?.[9] || ''}`, 163, 31);
                        doc.text(`${infFactura[i]?.[10] || ''}`, 136, 40);

                        doc.text(`${infFactura[i]?.[11] || ''}`, 144, 40);
                        //factura
                        doc.text(`${infFactura[i]?.[12] || ''}`, 180, 13);
                        doc.text(`${infFactura[i]?.[12] || ''}`, 80, 278);
                        nombreArchivo = infFactura[i]?.[12].trim();

                        //periodo facturado
                        doc.text(`${infFactura[i]?.[13] || ''}`, 176, 20);
                        doc.text(`${infFactura[i]?.[13] || ''}`, 40, 278);
                        periodoFacturado = infFactura[i]?.[13] || ''

                        doc.setFontSize(6);
                        doc.text(`${infFactura[i]?.[13] || ''}`, 80, 31);
                        doc.text(`${infFactura[i]?.[14] || ''}`, 105, 31);

                        doc.setFontSize(7);
                        //pago antes de 
                        doc.text(`${infFactura[i]?.[16] || ''}`, 179, 40);
                        doc.text(`${infFactura[i]?.[16] || ''}`, 43, 289);

                        //fecha ultimo pago
                        doc.text(`${infFactura[i]?.[17] || ''}`, 179, 27);
                        //valor antes
                        doc.text(`${infFactura[i]?.[18].trim() || ''}`, 183, 33);
                        //mes deuda
                        doc.text(`${infFactura[i]?.[19].trim() || ''}`, 152, 289);
                        //fecha corte
                        doc.text(`${infFactura[i]?.[20] || ''}`, 95, 40);

                    }

                    if (infFactura[i]?.[0] == "2") {
                        if (primeraPaginaConLlamada == 0) {
                            if (llamadasPrimeraPaginaConLlamada < minServiciosPagina) {
                                doc.setFontSize(7);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionConLlamada, baseValue + (cantidad));
                                baseValue += 3;
                                doc.text(`Servivio ${infFactura[i]?.[2] || ''}`, posicionConLlamada, baseValue + (cantidad));
                                doc.text(`Cuenta ${infFactura[i]?.[3] || ''}`, posicionConLlamada + 25, baseValue + (cantidad));
                                baseValue += 3;
                                numeroCuenta = infFactura[i]?.[3];
                                let salida = false;
                                let iterador = i + 1;
                                while (!salida) {
                                    if (infFactura[iterador]?.[0] == "3") {
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionConLlamada, baseValue + cantidad);
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, posicionConLlamada + 30, baseValue + cantidad);

                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[3] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth;

                                        doc.text(`${infFactura[iterador]?.[3] || ''}`, rightAlignedX, baseValue + cantidad);

                                        baseValue += 3;

                                    } else if (infFactura[iterador]?.[0] == "4") {
                                        doc.setFontSize(7);
                                        if (infFactura[iterador]?.[1] == "1") {
                                            doc.text('Cuenta vencida N° ' + numeroCuenta, 7, (baseValue + cantidad));
                                        }
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValue + cantidad);


                                    } else if (infFactura[iterador]?.[0] == "20") {
                                        const textWidth = doc.getTextWidth(`${infFactura[i]?.[2] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, 7, baseValue + (cantidad));
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValue + (cantidad));
                                        baseValue += 3;
                                    } else {
                                        salida = true;
                                        baseValue += 6;
                                    }
                                    iterador++;
                                }
                                baseValue += 3;
                                llamadasPrimeraPaginaConLlamada++;
                                i = iterador;

                            } else {
                                if (posicionConLlamada == 105) {
                                    baseValueConLlamada = 100;
                                    llamadasPrimeraPaginaConLlamada = 0;
                                    posicionConLlamada = 7;
                                    primeraPaginaConLlamada = 1;
                                    baseValue = 25;
                                    doc.addPage();

                                    imgUrl = imageData[3].imagen;
                                    imgUrlConsulta = imageDataLineas[3].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseValue = 25;
                                    llamadasPrimeraPaginaConLlamada = 0;
                                    posicionConLlamada = 105
                                    baseValueConLlamada = 25;


                                }

                            }
                        } else {
                            doc.text(nombreSuscriptor, 48, 20);
                            doc.text(telefono.trim(), 48, 25)
                            doc.text(direccion, 48, 31);
                            doc.text(facturaVenta, 160, 21);
                            doc.text(periodoFacturado, 162, 31);

                            if (llamadasPrimeraPaginaConLlamada < 7) {
                                doc.setFontSize(7);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionConLlamada, baseValue + (cantidad));
                                baseValue += 3;
                                doc.text(`Servivio ${infFactura[i]?.[2] || ''}`, posicionConLlamada, baseValue + (cantidad));
                                doc.text(`Cuenta ${infFactura[i]?.[3] || ''}`, posicionConLlamada + 25, baseValue + (cantidad));
                                baseValue += 3;
                                numeroCuenta = infFactura[i]?.[3];
                                let salida = false;
                                let iterador = i + 1;
                                while (!salida) {
                                    if (infFactura[iterador]?.[0] == "3") {
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, posicionConLlamada, baseValue + cantidad);
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, posicionConLlamada + 30, baseValue + cantidad);

                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[3] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth;

                                        doc.text(`${infFactura[iterador]?.[3] || ''}`, rightAlignedX, baseValue + cantidad);

                                        baseValue += 3;

                                    } else if (infFactura[iterador]?.[0] == "4") {
                                        doc.setFontSize(7);
                                        if (infFactura[iterador]?.[1] == "1") {
                                            doc.text('Cuenta vencida N° ' + numeroCuenta, 7, (baseValue + cantidad));
                                        }
                                        const textWidth = doc.getTextWidth(`${infFactura[iterador]?.[2] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValue + cantidad);


                                    } else if (infFactura[iterador]?.[0] == "20") {
                                        const textWidth = doc.getTextWidth(`${infFactura[i]?.[2] || ''}`);
                                        const rightAlignedX = posicionConLlamada + 93 - textWidth; // Ajusta 100 según la posición derecha deseada
                                        doc.setFontSize(7);
                                        doc.text(`${infFactura[iterador]?.[1] || ''}`, 7, baseValue + (cantidad));
                                        doc.text(`${infFactura[iterador]?.[2] || ''}`, rightAlignedX, baseValue + (cantidad));
                                        baseValue += 3;
                                    } else {
                                        salida = true;
                                        baseValue += 6;
                                    }
                                    iterador++;
                                }
                                baseValue += 3;
                                llamadasPrimeraPaginaConLlamada++;
                            } else {
                                if (posicionConLlamada == 105) {
                                    baseValueConLlamada = 100;
                                    llamadasPrimeraPaginaConLlamada = 0;
                                    posicionConLlamada = 7;
                                    primeraPaginaConLlamada = 1;
                                    baseValue = 25;
                                    doc.addPage();

                                    imgUrl = imageData[3].imagen;
                                    imgUrlConsulta = imageDataLineas[2].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseValue = 25;
                                    llamadasPrimeraPaginaConLlamada = 0;
                                    posicionConLlamada = 105
                                    baseValueConLlamada = 25;
                                }

                            }
                        }

                    }
                    if (infFactura[i]?.[0] == "8") {
                        if (infFactura[i]?.[1]?.includes('IVA') || infFactura[i]?.[1]?.includes('iva')) {
                            doc.text(`${infFactura[i]?.[1] || ''}`, 106, 115);
                            doc.text(`${infFactura[i]?.[2] || ''}`, 185, 115);
                        }
                    }


                    if (infFactura[i]?.[0] == "11") {
                        telefono = infFactura[i]?.[1] || '';
                    }
                    if (infFactura[i]?.[0] == "10") {
                        const paginaActual = doc.internal.getCurrentPageInfo().pageNumber;
                        doc.setPage(1);
                        doc.setFontSize(8);
                        const numeroOriginal = infFactura[i]?.[2];

                        //cupon
                        doc.setFontSize(7);
                        doc.text(`${infFactura[i]?.[1] || ''}`, 156, 40);
                        doc.text(`${infFactura[i]?.[1].trim() || ''}`, 144, 277);
                        doc.setFontSize(8);

                        if (numeroOriginal != null && !isNaN(numeroOriginal)) {
                            const numeroFormateado = formatearNumero(Number(numeroOriginal), 10); // Convierte a número

                            let formateador = new Intl.NumberFormat('es-ES', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            let valorFormateado = formateador.format(numeroOriginal);

                            doc.text(`${valorFormateado || ''}`, 108, 23);

                            doc.text(`${valorFormateado || ''}`, 176, 282);

                            const numeroFormateadoID = formatearNumero(Number(infFactura[i]?.[1]), 12); // Convierte a número
                            const codigoBarras = `${415}${7707271939062}${8020}${numeroFormateadoID}${3900}${numeroFormateado}${96}${infFactura[i]?.[3]}`;
                            doc.text(codigoBarras, 60, 234 + cantidad);
                            const codBarrasGrafico = generarCodigoBarrasBase64(codigoBarras);
                            if (codBarrasGrafico) {
                                // Insertar imagen del código de barras en el PDF
                                doc.addImage(codBarrasGrafico, "PNG", 50, 245, 107, 16); // Ajustar tamaño y posición
                            } else {
                                console.error("No se pudo generar la imagen del código de barras.");
                            }
                        } else {
                            console.error("Valor no válido para formatear:", numeroOriginal);
                        }
                        baseValue += 3;
                        doc.setPage(paginaActual);
                    }

                    if (infFactura[i]?.[0] == "12") {
                        if (adicionarPagina) {
                            doc.addPage();
                            imgUrl = imageData[2].imagen;
                            imgUrlConsulta = imageDataLineas[2].imagen;
                            if (tipoUsuario != 'consulta') {
                                doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                            } else {
                                doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                            }
                            adicionarPagina = false;
                            baseLlamadas = 18;
                            primeraPagina = 1;
                            posicionLlamada = 8;
                        }
                        if (primeraPagina == 0 && !adicionarPaginaTelefono) {
                            if (llamdasPrimeraPagina < 21) {
                                doc.setFontSize(4);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionLlamada, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[2] || ''}`, posicionLlamada + 10, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[3] || ''}`, posicionLlamada + 19, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[4] || ''}`, posicionLlamada + 25, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[5].trim() || ''}`, posicionLlamada + 37, baseLlamadas + (cantidad));
                                doc.setFontSize(3);
                                doc.text(`${infFactura[i]?.[6].trim() || ''}`, posicionLlamada + 40, baseLlamadas + (cantidad));
                                doc.setFontSize(4);
                                doc.text(`${infFactura[i]?.[7].trim() || ''}`, posicionLlamada + 45, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[8].trim() || ''}`, posicionLlamada + 59, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[9].trim() || ''}`, posicionLlamada + 69, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[10].trim() || ''}`, posicionLlamada + 82, baseLlamadas + (cantidad));

                                baseLlamadas += 3;
                                llamdasPrimeraPagina++;
                            } else {
                                if (posicionLlamada == 105) {
                                    baseLlamadas = 18;
                                    llamdasPrimeraPagina = 0;
                                    posicionLlamada = 8;
                                    primeraPagina = 1;
                                    doc.addPage();

                                    imgUrl = imageData[2].imagen;
                                    imgUrlConsulta = imageDataLineas[2].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseLlamadas = 100;
                                    llamdasPrimeraPagina = 0;
                                    posicionLlamada = 105
                                }

                            }
                        } else {
                            if (llamdasPrimeraPagina < 116) {
                                doc.setFontSize(6);
                                doc.text(nombreSuscriptor, 48, 20);
                                doc.text(telefono.trim(), 48, 25)
                                doc.text(direccion, 48, 31);
                                doc.text(facturaVenta, 160, 21);
                                doc.text(periodoFacturado, 162, 31);

                                doc.setFontSize(4);
                                doc.text(`${infFactura[i]?.[1] || ''}`, posicionLlamada, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[2] || ''}`, posicionLlamada + 10, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[3] || ''}`, posicionLlamada + 19, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[4] || ''}`, posicionLlamada + 25, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[5].trim() || ''}`, posicionLlamada + 37, baseLlamadas + (cantidad));
                                doc.setFontSize(3);
                                doc.text(`${infFactura[i]?.[6].trim() || ''}`, posicionLlamada + 40, baseLlamadas + (cantidad));
                                doc.setFontSize(4);
                                doc.text(`${infFactura[i]?.[7].trim() || ''}`, posicionLlamada + 45, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[8].trim() || ''}`, posicionLlamada + 59, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[9].trim() || ''}`, posicionLlamada + 69, baseLlamadas + (cantidad));
                                doc.text(`${infFactura[i]?.[10].trim() || ''}`, posicionLlamada + 82, baseLlamadas + (cantidad));

                                baseLlamadas += 2;
                                llamdasPrimeraPagina++;
                            } else {
                                if (posicionLlamada == 106) {
                                    baseLlamadas = 18;
                                    llamdasPrimeraPagina = 0;
                                    posicionLlamada = 8;
                                    primeraPagina = 1;
                                    doc.addPage();
                                    imgUrl = imageData[2].imagen;
                                    imgUrlConsulta = imageDataLineas[2].imagen;
                                    if (tipoUsuario != 'consulta') {
                                        doc.addImage(imgUrl, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    } else {
                                        doc.addImage(imgUrlConsulta, "JPEG", 0, 0, 210, 297); // Tamaño A4
                                    }
                                } else {
                                    baseLlamadas = 18;
                                    llamdasPrimeraPagina = 0;
                                    posicionLlamada = 106
                                }

                            }
                        }
                    }

                }
            }
            // Descargar el PDF
            setLoading(false);
            doc.save(nombreArchivo + ".pdf");
        } catch (error) {
            alert("Ocurrió un error al generar el PDF.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <LoaderDialog visible={loading} />
            <div className="card shadow-lg p-3 mb-5 bg-white rounded col-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
                <h3 className="text-center mb-4">Consulta de Facturas</h3>
                <div className="card-body">
                    <div className="input-group mb-3">
                        <input onKeyDown={validarInsercionNumeros}
                            type="text"
                            id="suscripcion"
                            className="form-control"
                            placeholder="Ingrese el número de suscripción"
                            aria-label="suscripcion"
                            aria-describedby="basic-addon"
                            value={suscripcion}
                            onChange={(e) => setSuscripcion(e.target.value)}
                        />
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <button className="btn btn-consulta mt-3" id="btn_consultar" onClick={manejarConsultaFacturas}>
                            Consultar facturas
                        </button>
                    </div>
                    {mensaje && <p className="text-danger mt-3 text-center">{mensaje}</p>}
                </div>
            </div>
            {Array.isArray(resultadosInvertidos) && resultadosInvertidos.length > 0 && (
                <div className="mt-4">
                    <div className="d-flex justify-content-center">
                        <h4>{resultadosInvertidos[0]?.nombre || "Nombre no disponible"}</h4>
                    </div>
                    <div className="d-flex flex-wrap gap-3 justify-content-center">
                        {resultadosInvertidos.map((resultado, index) => (
                            <div key={index} className="card shadow-sm" style={{ width: "18rem" }}>
                                <div className="card-body">
                                    <div className="d-flex justify-content-center p-0 m-0 position-relative">
                                        <h6 className="estado-etiqueta p-0 m-0 position-absolute">
                                            {resultado?.estado || ""}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-center p-0 m-0">
                                        <h4 className="p-0 m-0">
                                            {resultado?.mes || "Mes no disponible"} {resultado?.anio || "Año no disponible"}
                                        </h4>
                                    </div>
                                    <div className="card-text">
                                        <strong>Factura:</strong> {resultado?.factura || "No disponible"}
                                    </div>

                                    <div className="card-text text-danger">
                                        <strong>{resultado?.valor || "Valor no disponible"}</strong>
                                    </div>
                                    <div className="mt-3 d-flex justify-content-center">
                                        <button
                                            className="btn btn-danger"
                                            id={resultado?.estado?.split(' ')[1] || ""}
                                            onClick={() =>
                                                generarPDF(
                                                    resultado?.archivo || "",
                                                    resultado?.mes + resultado?.anio,
                                                    resultado?.valor || "",
                                                    resultado?.factura || ""
                                                )
                                            }
                                        >
                                            Descargar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ConsultaFacturas;

